import { linkToEquipmentDetail } from "#routers/links";
import { RoutingLink } from "#src/batteries-included-components/RoutingLink";
import {
  useClientSideSortingAndPagination,
  useTableSortingAndPagination,
} from "#src/components/Redux/reducers/tableStateReducer";
import { useStorageKey } from "#src/hooks/useStorageKey";
import { DataTable } from "@validereinc/common-components";
import type { FlowType } from "@validereinc/domain";
import React, { useMemo } from "react";

export const FlowEquipmentTable = ({
  variant,
  flow,
  isLoading,
}: {
  variant: "upstream" | "downstream";
  flow?: FlowType;
  isLoading: boolean;
}) => {
  const equipmentDetail = useMemo(
    () => flow?.[`${variant}_equipment`] ?? { id: undefined },
    [flow]
  );
  const [tableStateStorageKey] = useStorageKey(
    ["table-state"],
    "flows-equipment"
  );
  const [tableState, updateTableState] = useTableSortingAndPagination(
    undefined,
    undefined,
    tableStateStorageKey
  );
  const { items, pagination, sorting } = useClientSideSortingAndPagination(
    [{ ...equipmentDetail, type: "Equipment" }],
    tableState
  );

  const equipmentId = flow?.[`${variant}_equipment_id`] ?? "";

  return (
    <DataTable
      isLoading={isLoading}
      items={items}
      getItemId={() => equipmentId}
      headers={[
        {
          label: "Name",
          key: "name",
          renderComponent: ({ item }: any) => (
            <RoutingLink to={linkToEquipmentDetail(equipmentId)}>
              {item.name}
            </RoutingLink>
          ),
        },
        {
          label: "Type",
          key: "type",
        },
      ]}
      pagination={{
        ...pagination,
        showPageSizeControls: false,
      }}
      sorting={sorting}
      onPaginationChange={updateTableState}
      onSortChange={updateTableState}
    />
  );
};
